'use client'
import React, { useEffect } from 'react'

import { MantineProvider, Stack } from '@mantine/core'

import '@glideapps/glide-data-grid/dist/index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { ModalsProvider } from '@mantine/modals'
import SkellyBar from '../src/components/appshell/SkellyBar'
import { useSearchParams } from 'next/navigation'

const queryClient = new QueryClient()

const checkIsDesktop = () => {
  if (typeof window !== 'undefined') {
    return window?.location?.href?.includes('cla_desktop')
  }
  return false
}

export default function RootLayout({ children }: { children: any }) {
  const isDesktop = checkIsDesktop()

  return (
    <html lang='en'>
      <head>
        <link rel='shortcut icon' href='/form.svg' />
        <meta
          name='viewport'
          content='minimum-scale=1, initial-scale=1, width=device-width, user-scalable=no'
        />
      </head>
      <body>
        <MantineProvider>
          <ModalsProvider>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools initialIsOpen={false} />
              {/* Implement an appshell */}
              {/* @ts-ignore */}
              <Stack style={{ height: '97vh' }} spacing='xs'>
                {typeof window !== 'undefined' && isDesktop ? (
                  <>
                    <SkellyBar />
                    <div style={{ flexGrow: 1 }}>{children}</div>
                  </>
                ) : (
                  <div style={{ flexGrow: 1 }}>{children}</div>
                )}
              </Stack>
            </QueryClientProvider>
          </ModalsProvider>
        </MantineProvider>
      </body>
    </html>
  )
}

// export { metadata }
